import { useState, useEffect } from 'react';
import { trackEvent } from '../lib/tracking';
import { WHATSAPP_BASE, WHATSAPP_GENERIC_MESSAGE } from '../lib/constants';

export default function MobileCtaBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9998] md:hidden transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white border-t border-background-200/60 px-4 py-3 flex gap-3">
        <a
          href="#analise"
          onClick={() => trackEvent('form_start', { source: 'mobile_bar_carpete' })}
          className="flex-1 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-[14px] font-semibold py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          Solicitar análise
        </a>
        <a
          href={`${WHATSAPP_BASE}?text=${WHATSAPP_GENERIC_MESSAGE}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('whatsapp_carpete', { location: 'mobile_bar' })}
          className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer flex-shrink-0"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
      </div>
    </div>
  );
}